import { Component, OnInit } from '@angular/core';
import { ServiceService } from 'src/app/rest/service.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  constructor(public restService: ServiceService) { }

  ngOnInit(): void {
  }

}
